import { defineMessages } from 'react-intl'

export default defineMessages({
  shortMon: {
    id: 'SignUp.shortMon',
    defaultMessage: 'mon',
  },
  months: {
    id: 'Redeem.plans.months',
    defaultMessage: 'months',
  },
  month: {
    id: 'Redeem.plans.month',
    defaultMessage: 'month',
  },
  from: {
    id: 'PremiumPage.from',
    defaultMessage: 'From',
  },
  upgradeTo: {
    id: 'PremiumPage.upgradeTo',
    defaultMessage: 'Upgrade to',
  },
  get: {
    id: 'PremiumPage.get',
    defaultMessage: 'Get',
  },
  signUp: {
    id: 'Header.menuBar.signUp',
    defaultMessage: 'Sign up',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
})
